import { TOAST_TYPE } from "../../constants";
import { DROPDOWN_ROUTES } from "../../constants/customerApiRoutes";
import { buildQueryParams, showToastMessage } from "../../utils";
import API from "../axios";

export const getStates = async (handleData: CallableFunction) => {
  try {
    const response = await API.get(DROPDOWN_ROUTES.GET_STATES);
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  }
};

export const getCitiesByStateId = async (
  stateId: string,
  handleData: CallableFunction,
  filter: any = {}
) => {
  try {
    const queryString = buildQueryParams(filter);
    const response = await API.get(
      `${DROPDOWN_ROUTES.GET_CITY_BY_STATE_ID}/${stateId}?${queryString}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  }
};

export const getAreaByCityId = async (
  cityId: string,
  handleData: CallableFunction
) => {
  try {
    const response = await API.get(
      `${DROPDOWN_ROUTES.GET_AREA_BY_CITY_ID}?city_id=${cityId}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  }
};

export const getAllFactFeatures = async (
  handleData: CallableFunction,
  handleLoading: CallableFunction = () => {}
) => {
  try {
    const response = await API.get(`${DROPDOWN_ROUTES.GET_ALL_FACT_FEATURES}`);
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const getAmenities = async (handleData: CallableFunction) => {
  try {
    const response = await API.get(DROPDOWN_ROUTES.GET_AMENITIES);
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  }
};

export const getFacilities = async (handleData: CallableFunction) => {
  try {
    const response = await API.get(DROPDOWN_ROUTES.GET_FACILITIES);
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  }
};

export const getCustomerAllCategory = async (
  handleCategoryData: CallableFunction
) => {
  try {
    const response = await API.get(DROPDOWN_ROUTES.GET_ALL_CATEGORY);
    handleCategoryData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  }
};

export const getImageCategory = async (
  handleCategoryData: CallableFunction,
  handleLoading: CallableFunction = () => {}
) => {
  try {
    const response = await API.get(`${DROPDOWN_ROUTES.GET_IMAGE_CATEGORY}`);
    handleCategoryData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const getSubCategoryByCategory = async (
  categoryId: string,
  handleApiResponse: CallableFunction
) => {
  try {
    const response = await API.get(
      `${DROPDOWN_ROUTES.GET_SUB_CATEGORY_CATEGORY_ID}/${categoryId}`
    );
    handleApiResponse(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  }
};
